module.exports = {
  messages: {
    BUTTON_SHOW_MORE: 'Mehr',
    'JOBS_DATE_DAYS_LEFT_LABEL.one': 'Noch {variable_1} Tag',
    'JOBS_DATE_DAYS_LEFT_LABEL.other': 'Noch {variable_1} Tage',
    JOBS_DATE_EXPIRING_TODAY_LABEL: 'Nur noch heute',
    JOBS_HIGHLIGHT_URGENTLY_NEEDED: 'Dringend gesucht',
    JOBS_JOB_TEASER_EXTERNAL_JOB_HIGHLIGHT: 'Externes Job-Angebot',
    JOBS_JOB_TEASER_EXTERNAL_JOB_HIGHLIGHT_A11Y:
      'Externes Job-Angebot. Von einem Partner.',
    JOBS_JOB_TEASER_LINK_EXTERNAL_NEW_TAB_A11Y:
      'Klicke zum Öffnen des externen Job-Angebots in einem neuen Tab',
    JOBS_JOB_TEASER_LINK_NEW_TAB_A11Y:
      'Klicke zum Öffnen der vollständigen Job-Beschreibung in einem neuen Tab',
    JOBS_MULTILOCATION_MORE_LABEL: '+ {variable_1} weitere',
    JOBS_MULTILOCATION_SHOW_LESS_LABEL: 'Weniger anzeigen',
    JOBS_NEW_JOB_LABEL: 'Neu',
    JOBS_POSTING_GONE_SOON_MARKER: 'Bald weg',
    JOBS_POSTING_LAST_CHANCE_MARKER: 'Letzte Chance',
    JOBS_SALARY_XING_ESTIMATED: '(von XING geschätzt)',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO: 'Vor 30+ Tagen',
    JOBS_TIMESTAMP_30_PLUS_DAYS_AGO_A11Y: 'Vor über 30 Tagen veröffentlicht',
    JOBS_TIMESTAMP_JUST_NOW: 'Gerade eben',
    JOBS_TIMESTAMP_JUST_NOW_A11Y: 'Gerade veröffentlicht',
    JOBS_TIMESTAMP_N_DAYS_AGO: 'Vor {number} Tagen',
    JOBS_TIMESTAMP_N_DAYS_AGO_A11Y: 'Vor {number} Tagen veröffentlicht',
    JOBS_TIMESTAMP_N_HOURS_AGO:
      '{number, plural, =1 {Vor 1 Stunde} other {Vor # Stunden}}',
    JOBS_TIMESTAMP_N_HOURS_AGO_A11Y:
      '{number, plural, =1 {Vor einer Stunde veröffentlicht} other {Vor # Stunden veröffentlicht}}',
    JOBS_TIMESTAMP_YESTERDAY: 'Gestern',
    JOBS_TIMESTAMP_YESTERDAY_A11Y: 'Gestern veröffentlicht',
  },
};
